<template>
  <fieldset class="code-rule-fields" :disabled="disabled">
    <template v-if="method === 'template'">
      <div class="code-line template-rule-line">
        <el-select v-model="templateMode"
          ><el-option value="custom" label="自定义" /></el-select
        ><span>分隔符：</span
        ><el-select v-model="separatorChoice"
          ><el-option
            v-for="s in separators"
            :key="s.value"
            :value="s.value"
            :label="s.label"
        /></el-select>
        <span>中文处理</span
        ><el-select v-model="draft.chinese_mode"
          ><el-option
            v-for="mode in chineseModes"
            :key="mode"
            :value="mode"
            :label="chineseLabels[mode]"
        /></el-select>
      </div>
      <el-input
        v-model="templateText"
        class="template-code-input"
        clearable
        placeholder="输入自定义内容，或点击下方变量插入"
      />
      <div class="template-source-empty code-line">
        <span>来源货号为空：</span>
        <el-select v-model="draft.source_huohao_empty_mode">
          <el-option value="use_doudian_huohao" label="使用详情页货号替换" />
          <el-option value="continue_remaining" label="使用剩下变量继续生成" />
          <el-option value="skip" label="跳过不处理" />
        </el-select>
      </div>
      <div class="template-variable-picker">
        <div class="template-variable-buttons">
          <button
            v-for="v in variables"
            :key="v"
            class="template-variable-button"
            type="button"
            :disabled="disabled"
            @click="insertTemplateVariable(v)"
          >
            {{ variableLabel(v) }}
          </button>
          <small class="template-variable-note">点击选择变量（支持重复选择） 非本软件铺货的商品，来源变量无效</small>
        </div>
      </div>
    </template>
    <div v-else-if="method === 'affix'" class="code-line">
      <el-input v-model="draft.prefix" placeholder="前缀" /><span>＋</span
      ><el-select v-model="draft.variable"
        ><el-option
          v-for="v in variables"
          :key="v"
          :value="v"
          :label="variableLabel(v)" /></el-select
      ><span>＋</span><el-input v-model="draft.suffix" placeholder="后缀" />
    </div>
    <template
      v-else-if="
        [
          'replace_contains',
          'replace_exact',
          'spec_contains',
          'spec_exact',
        ].includes(method)
      "
    >
      <div v-for="(row, index) in draft.rows" :key="index" class="code-line">
        <span v-if="method.startsWith('spec_')"
          >规格名称{{ method === 'spec_exact' ? '精确为' : '包含' }}</span
        >
        <el-input
          v-if="method.startsWith('spec_')"
          v-model="row.keyword"
          placeholder="规格关键词"
        /><el-input v-else v-model="row.find" placeholder="编码关键词" />
        <span>替换为</span
        ><el-input
          v-if="method.startsWith('spec_')"
          v-model="row.value"
          placeholder="新的完整SKU编码"
        /><el-input v-else v-model="row.replacement" placeholder="替换内容" />
        <button
          class="plain"
          v-if="draft.rows.length > 1"
          @click="draft.rows.splice(index, 1)"
        >
          删除
        </button>
      </div>
      <button
        class="plain"
        :disabled="disabled || draft.rows.length >= 10"
        @click="addRow"
      >
        ＋添加规则（最多10条）
      </button>
    </template>
    <el-input
      v-else-if="method === 'delete_keywords'"
      v-model="keywordText"
      type="textarea"
      :rows="2"
      maxlength="100000"
      placeholder="删除关键词，多个用逗号或换行分隔"
    />
    <div v-else-if="method === 'set'" class="code-line">
      <el-input
        v-model="draft.value"
        maxlength="128"
        show-word-limit
        placeholder="统一修改为（最多128字符）"
      /><small>多SKU生成重复非空编码时，该商品将失败，不自动补流水号。</small>
    </div>
    <div v-else-if="method === 'random'" class="code-line">
      <el-select v-model="draft.base_variable"
        ><el-option
          v-for="v in variables"
          :key="v"
          :value="v"
          :label="variableLabel(v)" /></el-select
      ><el-select v-model="draft.separator"
        ><el-option
          v-for="s in separators"
          :key="s.value"
          :value="s.value"
          :label="s.label" /></el-select
      ><span>＋8位随机编码</span
      ><small>预览为示例，执行首次生成后固定，重试不重抽。</small>
    </div>
  </fieldset>
</template>

<script>
export const CODE_METHODS = [
  { value: 'template', label: '自定义编码' },
  { value: 'affix', label: '前缀＋变量＋后缀' },
  { value: 'replace_contains', label: '包含关键词替换' },
  { value: 'replace_exact', label: '关键词精准替换' },
  { value: 'delete_keywords', label: '删除关键词' },
  { value: 'set', label: '统一修改' },
  { value: 'random', label: '标识＋随机编码' },
  { value: 'spec_contains', label: '规格名称包含时设置' },
  { value: 'spec_exact', label: '规格名称精确时设置' },
  { value: 'multi', label: '多规则同时修改' },
]
export function newCodeOptions(method) {
  return JSON.parse(
    JSON.stringify(
      {
        template: {
          segments: [{ kind: 'literal', value: '' }],
          separator: '_',
          chinese_mode: 'none',
          source_huohao_empty_mode: 'continue_remaining',
        },
        affix: { prefix: '', variable: 'platform_product_id', suffix: '' },
        replace_contains: { rows: [{ find: '', replacement: '' }] },
        replace_exact: { rows: [{ find: '', replacement: '' }] },
        delete_keywords: { keywords: [] },
        set: { value: '' },
        random: { base_variable: 'platform_product_id', separator: '-' },
        spec_contains: { rows: [{ keyword: '', value: '' }] },
        spec_exact: { rows: [{ keyword: '', value: '' }] },
      }[method] || {}
    )
  )
}
const labels = {
  platform_product_id: '商品ID',
  spec_1: '规格1',
  spec_2: '规格2',
  spec_3: '规格3',
  sequence: '商品内流水号',
  sku_code: '当前SKU编码',
  source_product_id: '来源商品ID',
  source_huohao: '来源货号',
  huohao: '货号',
  wholesale_price: '批发价',
  source_platform_initial: '来源平台首字母',
  source_shop_initial: '来源店铺首字母',
}
export default {
  name: 'SkuCodeRuleFields',
  props: {
    value: { type: Object, required: true },
    method: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    variables: { type: Array, default: () => [] },
    chineseModes: { type: Array, default: () => ['none', 'remove'] },
  },
  data() {
    const segments = this.value.segments || []
    return {
      draft: JSON.parse(JSON.stringify(this.value)),
      templateMode: 'custom',
      templateText: segments
        .map((part) =>
          part.kind === 'literal'
            ? part.value
            : '[' + (labels[part.name] || part.name) + ']'
        )
        .join(this.value.separator || ''),
      separatorChoice: this.value.separator || '_',
      separators: [
        { value: '', label: '无分隔符' },
        { value: '/', label: '斜杠 /' },
        { value: '-', label: '横线 -' },
        { value: '_', label: '下划线 _' },
        { value: '|', label: '竖线 |' },
        { value: ' ', label: '空格' },
        { value: '#', label: '#' },
      ],
      chineseLabels: {
        none: '不处理',
        remove: '删除中文',
        pinyin: '转拼音',
        initials: '转拼音首字母',
      },
    }
  },
  computed: {
    keywordText: {
      get() {
        return (this.draft.keywords || []).join('，')
      },
      set(v) {
        this.$set(this.draft, 'keywords', [
          ...new Set(
            v
              .split(/[,，\r\n]+/)
              .map((x) => x.trim())
              .filter(Boolean)
          ),
        ])
      },
    },
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        if (JSON.stringify(v) !== JSON.stringify(this.draft)) {
          this.draft = JSON.parse(JSON.stringify(v))
          this.separatorChoice = v.separator || '_'
          this.templateText = this.renderTemplateText(
            v.segments || [],
            v.separator || ''
          )
        }
      },
    },
    templateText(value) {
      if (this.method !== 'template') return
      this.draft.segments = this.parseTemplateText(value)
      this.draft.separator = this.separatorChoice
    },
    separatorChoice(value) {
      if (this.method !== 'template') return
      this.draft.separator = value
      this.templateText = this.renderTemplateText(this.draft.segments, value)
    },
    draft: {
      deep: true,
      handler(v) {
        if (JSON.stringify(v) !== JSON.stringify(this.value))
          this.$emit('input', JSON.parse(JSON.stringify(v)))
      },
    },
  },
  methods: {
    variableLabel(v) {
      return labels[v] || v
    },
    renderTemplateText(segments, separator) {
      return segments
        .map((part) =>
          part.kind === 'literal'
            ? part.value
            : '[' + this.variableLabel(part.name) + ']'
        )
        .join(separator)
    },
    parseTemplateText(value) {
      const variablesByLabel = Object.fromEntries(
        this.variables.map((name) => [this.variableLabel(name), name])
      )
      const segments = []
      const pattern = /\[([^\]]+)\]/g
      let start = 0
      let match
      while ((match = pattern.exec(value))) {
        if (match.index > start)
          segments.push({
            kind: 'literal',
            value: value.slice(start, match.index),
          })
        if (variablesByLabel[match[1]])
          segments.push({ kind: 'variable', name: variablesByLabel[match[1]] })
        else segments.push({ kind: 'literal', value: match[0] })
        start = pattern.lastIndex
      }
      if (start < value.length || !segments.length)
        segments.push({ kind: 'literal', value: value.slice(start) })
      const normalized = []
      segments.forEach((part, index) => {
        if (
          part.kind === 'literal' &&
          part.value === this.separatorChoice &&
          segments[index - 1]?.kind === 'variable' &&
          segments[index + 1]?.kind === 'variable'
        )
          return
        if (part.kind === 'literal' && part.value && this.separatorChoice) {
          if (
            segments[index - 1]?.kind === 'variable' &&
            part.value.startsWith(this.separatorChoice)
          )
            part = {
              ...part,
              value: part.value.slice(this.separatorChoice.length),
            }
          if (
            segments[index + 1]?.kind === 'variable' &&
            part.value.endsWith(this.separatorChoice)
          )
            part = {
              ...part,
              value: part.value.slice(0, -this.separatorChoice.length),
            }
        }
        if (part.kind !== 'literal' || part.value !== '') normalized.push(part)
      })
      return normalized.length ? normalized : [{ kind: 'literal', value: '' }]
    },
    insertTemplateVariable(variable) {
      const label = this.variableLabel(variable)
      this.templateText +=
        (this.templateText ? this.separatorChoice : '') + '[' + label + ']'
    },
    addRow() {
      if (!this.disabled && this.draft.rows.length < 10)
        this.draft.rows.push(
          this.method.startsWith('spec_')
            ? { keyword: '', value: '' }
            : { find: '', replacement: '' }
        )
    },
  },
}
</script>

<style scoped>
.code-rule-fields {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  font-family: inherit;
  font-size: 12px;
}
.code-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 5px 0;
}
.code-line .el-input {
  width: 220px;
  max-width: 100%;
}
.code-line .el-select {
  width: 175px;
  max-width: 100%;
}
.template-rule-line .el-select:first-of-type {
  width: 180px;
}
.template-code-input {
  width: 500px;
  max-width: 100%;
  margin: 4px 0;
}
.template-source-empty {
  align-items: center;
}
.template-source-empty .el-select {
  width: 200px;
}
.template-variable-picker {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
}
.template-variable-picker > span {
  flex: 0 0 180px;
  padding-top: 7px;
}
.template-variable-buttons {
  display: flex;
  flex-wrap: wrap;
  max-width: 760px;
}
.template-variable-note {
  flex: 0 0 100%;
  padding-top: 6px;
  color: #909399;
}
.template-variable-button {
  min-width: 90px;
  height: 32px;
  margin: 0 -1px -1px 0;
  border: 1px solid #dce4ed;
  border-radius: 0;
  background: #fff;
  color: #303133;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}
.template-variable-button:hover {
  position: relative;
  z-index: 1;
  border-color: #409eff;
  color: #409eff;
}
.template-variable-button:disabled {
  cursor: not-allowed;
  color: #c0c4cc;
}
.code-rule-fields > .el-textarea {
  width: 420px;
  max-width: 100%;
}
.code-line small {
  color: #8492a6;
  font-size: 12px;
}
.plain {
  border: 1px solid #dce4ed;
  border-radius: 3px;
  background: #fff;
  color: #2878ce;
  padding: 5px 9px;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}
.code-rule-fields ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-family: inherit;
  font-size: 12px;
}
.code-rule-fields ::v-deep .el-input__icon {
  line-height: 28px;
}
@media (max-width: 700px) {
  .template-rule-line .el-select,
  .template-source-empty .el-select {
    width: 100%;
  }
  .template-variable-picker {
    flex-direction: column;
  }
  .template-variable-picker > span {
    flex-basis: auto;
  }
  .code-line .el-input,
  .code-line .el-select {
    width: 100%;
  }
}
</style>
